var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-bar-close-button",on:{"click":_vm.close}},[_c('i',{staticClass:"icon-close"})])
}
var staticRenderFns = []

export { render, staticRenderFns }